import React from 'react';
import {getSeverityColor, getSeverityFilled} from './color';
import { Box } from '@barracuda-internal/bds-core'

function SmallSeverityBars({ severity , isSafe }) {
  const color = getSeverityColor(severity , isSafe);
  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'flex-start' }}>
      {Array.from({ length: 4 }).map((_, i) => (
        <Box key={i} sx={{ width: 22, height: 6, borderRadius: i === 0 ? 3 : 0, bgcolor: i < severity ? color : '#e6e9ec' }} />
      ))}
    </Box>
  );
}

export { SmallSeverityBars };